import React from 'react';
import { FormHandles, SubmitHandler } from '@unform/core';
import { Form } from '@unform/web';

import Input from '../../../components/FormInput';
import Button from '../../../components/Button';

import { Container } from './styles';

interface Props {
  formRef: React.Ref<FormHandles>;
  buttonText: string;
  initialData?: Segment;
  handleSubmit: SubmitHandler;
}

interface Segment {
  segmentId: number;
  name: string;
}

const FormSegment: React.FC<Props> = props => {
  return (
    <Container>
      <Form
        ref={props.formRef}
        initialData={props.initialData}
        onSubmit={props.handleSubmit}
      >
        <h2>Name</h2>
        <Input type="text" name="name" placeholder="Enter the title" />

        <Button type="submit" $width="200px">
          {props.buttonText}
        </Button>
      </Form>
    </Container>
  );
};

export default FormSegment;
